/**
 * @Date:   11.08.2020
 * @Email:  info@monster010.de
 * @Filename: effect.blink.js
 * @Last modified time: 11.08.2020
 * @Copyright: Copyright (c) 2020 monster010.de
 */
 (function($) {
	 $.fn.blink = function(option) {
		 var defaults = {
			 delay: 150,
			 class: 'hide',
			 pulses: 5
		 };
		 var options = $.extend(defaults, option);

		 return this.each(function() {
			 var obj = $(this);
			 var count = 0;

			var interval = setInterval(function() {
				if(count == options.pulses) clearInterval(interval);

				 if ($(obj).hasClass(options.class)) {
					 $(obj).removeClass(options.class);
				 }
				 else {
					  $(obj).addClass(options.class);
				 }

				 count++;
			 }, options.delay);
		 });
	 };
 }(jQuery));
